export const LOCATION = "Kansas City Metro";

export const ADDRESS = {
  name: "MSK Hotels",
  street: "8101 N Church Road",
  city: "Kansas City, MO 64158",
  note: "At Fairfield Inn & Suites Kansas City Liberty",
};
const ADDRESS_Q = encodeURIComponent(`${ADDRESS.street}, ${ADDRESS.city}`);
export const MAP_EMBED_URL = `https://www.google.com/maps?q=${ADDRESS_Q}&output=embed`;
export const DIRECTIONS_URL = `https://www.google.com/maps/dir/?api=1&destination=${ADDRESS_Q}`;

export const NAV = [
  { to: "/about", label: "About" },
  { to: "/approach", label: "Approach" },
  { to: "/operations", label: "Operations" },
  { to: "/portfolio", label: "Portfolio" },
  { to: "/leadership", label: "Leadership" },
  { to: "/why-partner", label: "Why MSK" },
  { to: "/careers", label: "Careers" },
];

export const BRAND_LOGOS = [
  { id: "marriott", name: "Marriott International", src: "/images/brands/marriott.svg", h: "h-9" },
  { id: "fairfield", name: "Fairfield by Marriott", src: "/images/brands/fairfield.png", h: "h-12" },
  { id: "springhill", name: "SpringHill Suites by Marriott", src: "/images/brands/springhill-suites.svg", h: "h-7" },
  { id: "ihg", name: "IHG Hotels & Resorts", src: "/images/brands/ihg.svg", h: "h-7" },
  { id: "hie", name: "Holiday Inn Express", src: "/images/brands/holiday-inn-express.svg", h: "h-14" },
  { id: "choice", name: "Choice Hotels", src: "/images/brands/choice-hotels.svg", h: "h-10" },
  { id: "sleep", name: "Sleep Inn", src: "/images/brands/sleep-inn.svg", h: "h-14" },
];

export const EXPERTISE = [
  { icon: "BadgeCheck", title: "Brand standards & QA audits", text: "Self-audit before every MI Health Check or brand QA visit. Every finding gets a named owner and a close date. We use the brand's standards manual as our operating manual." },
  { icon: "LineChart", title: "Revenue management (RMAS)", text: "Marriott RMAS on a weekly call with the COO. The forecast, pace and rate are owned on property and benchmarked against the STR comp set." },
  { icon: "Megaphone", title: "Sales & distribution", text: "Named corporate and group accounts sold face to face. Brand Digital Marketing, clean OTA content and loyalty enrollment are run as standing programs." },
  { icon: "HeartHandshake", title: "Guest experience & recovery", text: "GuestVoice alerts and GXP cases are answered the same day and read aloud at the daily huddle. The front desk is empowered to recover on the spot." },
  { icon: "Landmark", title: "Financial reporting (USALI)", text: "USALI books, a monthly close against budget and prior year, and separated duties. The owner report is the same one the brand receives." },
  { icon: "Hammer", title: "Capital projects & PIP", text: "PIP calendars kept on date, a funded FF&E reserve and competitive bids. Renovations are phased so the hotel stays open and guest data sets the scope." },
  { icon: "Users", title: "People & training", text: "Brand training before the first shift, DLZ completions tracked, cross-training across departments, and recognition tied to what guests say." },
  { icon: "KeyRound", title: "Transition & takeover", text: "A day-one cutover plan for systems, staff, banking and brand notifications, backed by a leadership bench that is ready at closing." },
];

export const TAKEOVER = [
  { phase: "Before closing", title: "Due diligence", points: ["Property walk with engineering and the brand PIP", "Guest-data and review diagnosis", "Staffing, payroll and vendor contract review", "Day-one budget and capital plan"] },
  { phase: "Day 1", title: "Transition", points: ["GM of record and department heads confirmed", "PMS, payroll (ADP), banking and brand systems cut over", "Associates welcomed and re-onboarded", "Brand regional team notified"] },
  { phase: "First 90 days", title: "Stabilize", points: ["RMAS and Brand Digital live", "Self-audit and quality pre-check filed", "PIP calendar and FF&E reserve set", "First owner report delivered to the brand"] },
  { phase: "Ongoing", title: "Report & improve", points: ["Daily huddle, weekly COO review", "Monthly USALI close and owner report", "Quarterly portfolio benchmarking", "Annual plan built with department heads"] },
];

export const CAREERS = [
  {
    id: "hr-manager",
    title: "Human Resources Manager",
    featured: true,
    location: "Kansas City Metro · Above property",
    type: "Full-time",
    text: "Own recruiting, onboarding, retention and compliance across MSK hotels. You'll partner with the COO and General Managers, run ADP payroll administration and build the training calendar that gets every associate brand-ready before their first shift.",
  },
  { id: "front-desk", title: "Front Desk Agent", location: "Liberty, MO", type: "Full-time / Part-time", text: "Be the first welcome our guests receive. You'll handle arrivals and departures, resolve issues on the spot and enroll guests in the loyalty program." },
  { id: "room-attendant", title: "Housekeeping Room Attendant", location: "Liberty, MO", type: "Full-time / Part-time", text: "Prepare spotless, comfortable rooms to brand standard. You'll work with a team whose inspections every departure room gets." },
  { id: "maintenance", title: "Maintenance / Engineering Technician", location: "Liberty, MO", type: "Full-time", text: "Keep the hotel running. You'll handle preventive maintenance, room repairs, life-safety checks and renovation support." },
  { id: "night-auditor", title: "Night Auditor", location: "Liberty, MO", type: "Full-time", text: "Run the overnight front desk and close the day's books accurately, while keeping guests safe and cared for." },
  { id: "breakfast", title: "Breakfast Attendant", location: "Liberty, MO", type: "Part-time · Mornings", text: "Set up and host the brand breakfast. You'll keep the buffet fresh, follow temperature and food-safety logs, and greet guests warmly." },
];

export const CAREER_ROLES = [...CAREERS.map((c) => c.title), "General Application"];

export const IMAGES = {
  lobby: "/images/hero-lobby.webp",
  guestroom: "/images/guestroom.webp",
  exterior: "/images/exterior.webp",
  bathroom: "/images/bathroom.webp",
  breakfast: "/images/breakfast.webp",
  corridor: "/images/corridor.webp",
  operations: "/images/operations.webp",
  skyline: "/images/skyline.webp",
};

export const STATS = [
  { value: "5", label: "Hotels", note: "Owned or overseen by MSK principals" },
  { value: "437", label: "Keys", note: "Across the Kansas City metro" },
  { value: "4", label: "Brands", note: "Marriott, IHG and Choice flags" },
  { value: "$1.8M", label: "Renovation", note: "Liberty, funded by ownership" },
  { value: ">35%", label: "GOP margin", note: "Multi-property operating record" },
  { value: "<23%", label: "Labor", note: "Of revenue, held with discipline" },
];

export const PRINCIPLES = [
  {
    key: "local",
    title: "Local & Present",
    text: "The principals live in the Kansas City metro, and every hotel we own or oversee is in it. We hear guests, associates and corporate accounts directly, not through a monthly report.",
  },
  {
    key: "accountability",
    title: "An Owner's Accountability",
    text: "The people who sign the note run the hotel. Staffing, capital and service-recovery decisions are made the way owners make them, with the long-term value of the asset in view.",
  },
  {
    key: "data",
    title: "Step by Step, With Data",
    text: "We diagnose from guest data, fix the biggest cause first, and measure the result before moving to the next. Our Liberty renovation shows the method at work.",
  },
];

export const PILLARS = [
  {
    n: "01",
    title: "Acquire with a plan",
    summary: "We underwrite as owner-operators. We know the market, the product and the team before closing.",
    points: [
      "Market, product and team diligence completed before we commit",
      "Capital needs identified at acquisition, not discovered later",
      "A named leadership bench and reporting cadence ready for day one",
    ],
  },
  {
    n: "02",
    title: "Invest in the product",
    summary: "Capital is planned at acquisition and funded. Liberty's full renovation launched within nine months of ownership.",
    points: [
      "Funded FF&E reserve and a PIP calendar kept on schedule",
      "Competitive bids above set thresholds",
      "Renovation scope driven by what guests tell us, room by room",
    ],
  },
  {
    n: "03",
    title: "Put the right team on property",
    summary: "Named leaders in every department, coached daily by principals who are on site.",
    points: [
      "General Manager of record working on property",
      "Department heads accountable for front office, housekeeping, engineering and sales",
      "Brand training for every guest-facing associate before the first shift",
    ],
  },
  {
    n: "04",
    title: "Run the brand playbook",
    summary: "We adopt brand programs as standing disciplines from day one. We don't negotiate them away.",
    points: [
      "Revenue Management Advisory Services (RMAS) on the weekly call",
      "Brand Digital Marketing for listings, reviews and social",
      "GuestVoice alerts and GXP cases answered the same day",
      "MI Health Check readiness, with a self-audit before every visit",
    ],
    programs: ["RMAS", "Brand Digital", "GuestVoice", "MI Health Check"],
  },
  {
    n: "05",
    title: "Measure, report, repeat",
    summary: "One dashboard, monthly owner reviews and transparent reporting to the brand's regional team.",
    points: [
      "USALI monthly close against budget and prior year",
      "Weekly pace, forecast and comp-set review",
      "Quarterly portfolio benchmarking across every hotel",
    ],
  },
];

export const DEPARTMENTS = [
  {
    icon: "Crown",
    title: "Executive Leadership",
    lead: "President & CEO with the ownership group",
    text: "Sets strategy, allocates capital and owns the franchise relationship. Reviews every hotel's performance monthly with the COO and Controller.",
    points: ["Capital planning", "Brand & franchise relationship", "Monthly performance review"],
  },
  {
    icon: "ConciergeBell",
    title: "Operations & Guest Service",
    lead: "COO / VP Operations, Certified GM",
    text: "Oversees the GM and daily standards at every property, from service recovery and department-head coaching to the guest-feedback trends reviewed each week.",
    points: ["GM oversight & daily standards", "Same-day service recovery", "Housekeeping & rooms quality"],
  },
  {
    icon: "Landmark",
    title: "Finance & Controller",
    lead: "Director of Finance / Controller",
    text: "Owns the USALI monthly close, the annual budget built with department heads, internal controls and the monthly owner report.",
    points: ["USALI monthly close", "Budgets & FF&E reserve", "Owner reports & internal controls"],
  },
  {
    icon: "LineChart",
    title: "Revenue Management",
    lead: "COO with Marriott RMAS",
    text: "Weekly forecast, pace and rate strategy with Marriott's Revenue Management Advisory Services, benchmarked against the comp set.",
    points: ["Marriott RMAS partnership", "Weekly pace vs. forecast vs. budget", "Comp-set index tracking"],
  },
  {
    icon: "Megaphone",
    title: "Sales & Marketing",
    lead: "Director of Sales with an outside agency",
    text: "Corporate and group accounts sold face to face, supported by Brand Digital Marketing and loyalty enrollment run as standing programs.",
    points: ["Corporate & group accounts", "Brand Digital Marketing", "Loyalty enrollment goals"],
  },
  {
    icon: "Users",
    title: "People & Training",
    lead: "COO with HR leadership",
    text: "Recruiting, onboarding and retention, with payroll on ADP. Brand training comes before the first shift, and recognition is tied to guest comments.",
    points: ["ADP payroll", "Brand training & DLZ tracking", "Cross-training across departments"],
  },
  {
    icon: "Wrench",
    title: "Engineering & Capital Projects",
    lead: "CEO above property, Chief Engineer on property",
    text: "Preventive maintenance and room-inspection calendars, life safety, PIP delivery and renovation projects bid competitively.",
    points: ["PM & RPM calendar", "Life safety", "PIP & renovation delivery"],
  },
  {
    icon: "ShieldCheck",
    title: "Technology & Security",
    lead: "CEO, enterprise infrastructure background",
    text: "Brand-compliant networks, PCI, mobile key and guestroom entertainment kept to standard, backed by a written crisis-management plan.",
    points: ["Brand network standards", "PCI & data security", "Crisis plan & 24/7 escalation"],
  },
  {
    icon: "Building2",
    title: "Real Estate & Acquisitions Advisory",
    lead: "Co-owner oversight with an outside advisor",
    text: "Portfolio oversight and acquisition underwriting, supported by an outside commercial real-estate advisor with hotel-ownership and franchise-transition experience.",
    points: ["Acquisition underwriting", "Franchise transition", "Market intelligence"],
  },
];

export const ON_PROPERTY = [
  { role: "General Manager", text: "The GM of record works on property and owns execution: standards, staffing, service recovery and results." },
  { role: "Assistant General Manager", text: "Leads the daily huddle, keeps standards and training on track, and reviews guest cases every day." },
  { role: "Front Office", text: "Owns the arrival experience, same-day recovery at the desk and loyalty enrollment." },
  { role: "Housekeeping", text: "Handles room assignments, inspects every departure room and runs linen and supply counts." },
  { role: "Engineering", text: "Keeps the preventive-maintenance and room-inspection calendars, life safety and daily repairs." },
  { role: "Sales", text: "Sells named corporate and group accounts, with a weekly pace review alongside the COO." },
];

export const CADENCE = [
  { when: "Daily", title: "Property huddle", text: "AGM and department heads cover arrivals, room status, staffing, guest cases and safety." },
  { when: "Weekly", title: "Operations & revenue call", text: "COO, AGM, Sales, Front Office and RMAS review pace, forecast, rate, comp set and maintenance." },
  { when: "Monthly", title: "Close & owner review", text: "Controller presents the USALI P&L against budget and prior year, with GOP, labor and action items." },
  { when: "Quarterly", title: "Brand & portfolio review", text: "Comp-set index, guest-feedback trends, quality-audit readiness and the capital plan across hotels." },
  { when: "Annual", title: "Plan & budget", text: "Strategic plan, department budgets built with department heads, FF&E reserve and PIP milestones." },
];

export const ISSUE_FLOW = [
  { step: "Guest feedback", sub: "Surveys, cases, reviews" },
  { step: "Front desk", sub: "Same day" },
  { step: "AGM", sub: "Daily review" },
  { step: "COO", sub: "Weekly trend & plan" },
  { step: "CEO", sub: "Monthly review" },
];

export const HOTELS = [
  {
    id: "liberty",
    brand: "Fairfield Inn & Suites",
    logo: "/images/brands/fairfield.png", logoH: "h-10",
    parent: "Marriott",
    name: "Fairfield Inn & Suites Kansas City Liberty",
    city: "Liberty, MO",
    keys: 99,
    status: "Owned & Operated",
    note: "Acquired December 2025 and managed directly by MSK Hotels. Full renovation under way.",
  },
  {
    id: "legends",
    brand: "Fairfield Inn & Suites",
    logo: "/images/brands/fairfield.png", logoH: "h-10",
    parent: "Marriott",
    name: "Fairfield Inn & Suites Kansas City at The Legends",
    city: "Kansas City, KS",
    keys: 88,
    status: "Co-sponsored",
    note: "New-construction hotel held through an affiliated entity of MSK co-owner Bharat Sutariya, MD, and managed by a third party under his oversight.",
  },
  {
    id: "grandview",
    brand: "Holiday Inn Express",
    logo: "/images/brands/holiday-inn-express.svg", logoH: "h-12",
    parent: "IHG",
    name: "Holiday Inn Express Grandview",
    city: "Grandview, MO",
    keys: 72,
    status: "Co-sponsored",
    note: "Stabilized hotel acquired in 2026 through an affiliated entity of MSK co-owner Bharat Sutariya, MD.",
  },
  {
    id: "olathe",
    brand: "Sleep Inn",
    logo: "/images/brands/sleep-inn.svg", logoH: "h-12",
    parent: "Choice Hotels",
    name: "Sleep Inn Olathe",
    city: "Olathe, KS",
    keys: 76,
    status: "Co-sponsored",
    note: "A decommissioned asset fully remodeled and relaunched through an affiliated entity of MSK co-owner Bharat Sutariya, MD.",
  },
  {
    id: "springhill",
    brand: "SpringHill Suites",
    logo: "/images/brands/springhill-suites.svg", logoH: "h-6",
    parent: "Marriott",
    name: "SpringHill Suites Overland Park",
    city: "Overland Park, KS",
    keys: 102,
    status: "Proposed",
    note: "MSK Hotels management proposed at the closing of the sponsor group's acquisition.",
  },
];

export const LIBERTY_TIMELINE = [
  { when: "Dec 2025", title: "Acquired", text: "Full renovation identified at acquisition. Prior manager retained through the transition." },
  { when: "Jun 2026", title: "Direct management", text: "Moonga Pandya became GM of record, a quality pre-check was filed and the leadership bench installed." },
  { when: "Q3 2026", title: "Renovation launched", text: "Design complete. FF&E ordering and construction quotations under way." },
  { when: "Within 7–8 months", title: "Completion", text: "Phased so the hotel stays open, then measured against brand standards." },
];

export const LIBERTY_FIXES = [
  { heard: "Showers, tubs, bathroom size and layout", action: "Bathroom rebuild and fixture replacement" },
  { heard: "Mold, mildew and other odors", action: "Moisture and HVAC remediation, removal of odor sources" },
  { heard: "Carpet, room condition and bed comfort", action: "Guestroom soft goods, carpet and mattress program" },
  { heard: "Room size and functionality", action: "Layout and furniture refresh within the existing footprint" },
];

export const LIBERTY_RECOVERY = [
  { k: "Team", v: "AGM, Front Office Manager, Director of Sales and housekeeping co-leads in place." },
  { k: "Rooms", v: "A supervisor inspects every departure room. Deep-clean and odor rotation, plus preventive maintenance documented three times a year." },
  { k: "Service", v: "Every guest alert and case is answered the same day, and comments are read at the daily huddle." },
  { k: "Breakfast", v: "Brand buffet specification, temperature logs and food-safety-certified managers." },
  { k: "Reporting", v: "Weekly COO review, with monthly progress reports to the brand's regional team." },
];

// Headshots: drop a new file at the same path (or change `photo`) to swap. Set photo to null for a monogram.
export const LEADERS = [
  {
    id: "dhaval-pandya",
    name: "Dhaval Pandya",
    title: "President & Chief Executive Officer",
    initials: "DP",
    photo: "/images/team/dhaval-pandya.jpg",
    summary:
      "A finance and infrastructure executive with more than 20 years directing multi-million-dollar budgets, vendor negotiations and cross-functional teams.",
    bio: [
      "Dhaval leads capital planning, financial reporting and the franchise relationship for MSK Hotels. He is co-owner of Fairfield Inn & Suites Kansas City Liberty and is directing the $1.8 million renovation now under way.",
      "Above property, he leads engineering and capital projects as well as technology and security. His enterprise career at H&R Block includes infrastructure for a nationwide retail network and leadership of a FinOps program covering multi-million-dollar budgets.",
    ],
    focus: ["Capital planning", "Franchise relationship", "Engineering & capital projects", "Technology & security"],
    credentials: ["Microsoft Certified: Azure Solutions Architect Expert", "Professional Scrum Master I", "B.Com, Hemchandracharya North Gujarat University"],
  },
  {
    id: "moonga-pandya",
    name: "Moonga Pandya",
    title: "Chief Operating Officer / VP Operations",
    initials: "MP",
    photo: "/images/team/moonga-pandya.jpg",
    summary:
      "A Certified General Manager with more than 10 years of hands-on, multi-property management, and General Manager of record at Fairfield Inn & Suites Kansas City Liberty.",
    bio: [
      "Moonga ran five Wyndham-branded hotels of 80 to 120 rooms across the Midwest and supervised more than 40 associates in front office, housekeeping, maintenance and food and beverage. She held full P&L responsibility, with GOP margins consistently above 35 percent and labor below 23 percent of revenue, and earned multiple Best of Wyndham guest-satisfaction awards.",
      "At MSK she leads operations and guest service, housekeeping and rooms quality, revenue management with Marriott RMAS, and people and training. She reviews guest-feedback trends every week.",
    ],
    focus: ["Operations & guest service", "Rooms quality", "Revenue management", "People & training"],
    credentials: ["Certified General Manager", "General Manager training completed", "B.A., Magadh University"],
  },
  {
    id: "bharat-sutariya",
    name: "Bharat Sutariya, MD",
    title: "Co-owner · Strategic Investment & Portfolio Oversight",
    initials: "BS",
    photo: "/images/team/bharat-sutariya.jpg",
    summary:
      "An investor and executive with a 15-year record of identifying, acquiring and improving assets across hospitality, industrial and residential real estate.",
    bio: [
      "Over the past four years, Dr. Sutariya has built an active Midwest hotel portfolio. It includes a new-construction Fairfield Inn & Suites at The Legends, the remodel and relaunch of a decommissioned Sleep Inn in Olathe, and the 2026 acquisition of Holiday Inn Express Grandview.",
      "He provides strategic investment and portfolio oversight for MSK and benchmarks every hotel against the owners' Marriott properties. He is also Chief Medical Officer and SVP at Oracle Health, following senior roles at Deloitte and Cerner.",
    ],
    focus: ["Portfolio oversight", "Acquisitions", "Turnaround", "Third-party oversight"],
    credentials: ["M.D., M.S. and B.S., Wayne State University", "Board-certified emergency physician", "Fellow, American College of Emergency Physicians"],
  },
];

export const WHY_PILLARS = [
  {
    icon: "BadgeCheck",
    title: "Brand-standard compliance",
    text: "We adopt brand programs as standing disciplines rather than negotiating them. We run a self-audit before every quality visit and close findings by a named owner on a date.",
    points: ["RMAS & Brand Digital Marketing from day one", "Self-audit & pre-check before every MI Health Check", "Brand training before the first shift"],
  },
  {
    icon: "Eye",
    title: "Transparency",
    text: "The same monthly report the principals review goes to the brand. We show the numbers that aren't yet where they should be, along with the plan behind them.",
    points: ["Monthly owner report for each hotel", "Same-day notice of significant incidents", "Monthly progress reports until scores are back above brand"],
  },
  {
    icon: "MapPin",
    title: "On-site presence",
    text: "The principals live in the Kansas City metro, and the GM of record works on property. Problems get handled the same day by someone whose name is on the note.",
    points: ["Every hotel within one metro", "Named leader in every department", "Daily huddle, weekly COO review"],
  },
  {
    icon: "Scale",
    title: "Financial discipline",
    text: "Our operating record: GOP above 35 percent and labor under 23 percent of revenue. We keep USALI books, separate duties and bid competitively above set thresholds.",
    points: ["USALI monthly close against budget", "Funded, escrowed FF&E reserve", "Separated duties for cash, purchasing & payroll"],
  },
];

export const BRAND_REPORT = [
  "Occupancy, ADR and RevPAR index against the comp set",
  "Guest-satisfaction trend and case response",
  "Labor as a percentage of revenue",
  "Quality-audit readiness and open findings",
  "Capital and PIP progress",
  "Same-day notice of significant incidents",
];

export const OWNER_POINTS = [
  { title: "Aligned interests", text: "We own hotels too, so decisions are made with the long-term value of the asset in view." },
  { title: "Money stays in the hotel", text: "An owner-operator doesn't pay a third party for decisions it can make on site. We reinvest in the product and the team." },
  { title: "Speed", text: "A maintenance issue, a rate opportunity or a guest complaint gets handled the same day." },
  { title: "Proven turnaround playbook", text: "We diagnose from data, fix the biggest cause first, then measure the result before moving on." },
];

export const INQUIRY_TYPES = ["Management Partnership", "Brand Relations", "Ownership & Investment", "Careers", "Other"];

export const CC_LOOP = [
  { n: "01", verb: "Review", title: "Morning briefing", text: "Overnight changes, financial exposure and today's key decisions, ready before the first huddle." },
  { n: "02", verb: "Decide", title: "Owner intelligence", text: "Performance, revenue loss, guest exposure and risk in one view, with recommendations on what to do next." },
  { n: "03", verb: "Act", title: "Work board", text: "Every decision becomes owned work, with a priority, an accountable person and a due date." },
  { n: "04", verb: "Verify", title: "Performance trends", text: "ADR, RevPAR, revenue mix and exposure tracked over time, so we know whether the action worked." },
];

export const CC_WORKSPACES = [
  { icon: "BedDouble", title: "Rooms & housekeeping", text: "Room status, departure inspections, deep-clean rotation and out-of-order tracking." },
  { icon: "Wrench", title: "Maintenance", text: "Work orders, the preventive-maintenance calendar, room inspections and life-safety checks." },
  { icon: "Users", title: "Staffing", text: "Schedules against forecast, open shifts, labor targets and training completions." },
  { icon: "ClipboardList", title: "Shift reports", text: "Structured handoffs from every shift: incidents, guest issues and follow-ups." },
  { icon: "LineChart", title: "Revenue strategy", text: "Pace, pickup, rate position against the comp set, and the weekly RMAS agenda." },
  { icon: "Landmark", title: "Finance center", text: "USALI close status, budget variance, payables and the monthly owner report." },
  { icon: "ShieldCheck", title: "Risk protection", text: "Brand-audit readiness, open findings, incidents, insurance and compliance dates." },
  { icon: "Rocket", title: "Growth engine", text: "Corporate accounts, group leads, loyalty enrollment and the acquisition pipeline." },
];

export const CC_RHYTHM = [
  { k: "Ask", v: "what changed." },
  { k: "Decide", v: "what matters most." },
  { k: "Act:", v: "who owns the response?" },
  { k: "Verify:", v: "did the result improve?" },
];
